<template>
  <div class="snail_5thLeading">
    <!-- 活动标题 -->
    <div v-wechat-title="'最無厘頭放置手遊《最強蝸牛》'"></div>


    <div class="snail_5thLeading_box">
      <header class="snail-header">
        <div class="video-btn" :class="{ playing: isPlaying }" @click="toggleMusic"></div>

        <!-- 背景音乐 -->
        <audio ref="bgMusic" loop>
          <source src="./snail.mp3" type="audio/mpeg" />
        </audio>
      </header>
      <div class="snail_5thLeading_page">
        <div class="big-title"></div>
        <div class="small-title"></div>
        <div class="fb-btn" @click="goLink">
        </div>

        <div class="tip-btn"></div>

        <div class="tab-carousel-container">
          <!-- Tabs -->
          <!-- 每个 tab 独立绝对定位 -->
          <!-- 左箭头 -->
          <img src="https://download4.qcplay.com/snail/snail_5thLeading/left_arrow.png" class="arrow arrow-left"
            @click="slidePrev" />

          <!-- 右箭头 -->
          <img src="https://download4.qcplay.com/snail/snail_5thLeading/right_arrow.png" class="arrow arrow-right"
            @click="slideNext" />

          <img :src="currentTab === 0 ? tabImgs.active[0] : tabImgs.normal[0]" class="tab-btn tab-1"
            :class="{ 'tab-active': currentTab === 0 }" @click="switchTab(0)">

          <img :src="currentTab === 1 ? tabImgs.active[1] : tabImgs.normal[1]" class="tab-btn tab-2"
            :class="{ 'tab-active': currentTab === 1 }" @click="switchTab(1)">

          <img :src="currentTab === 2 ? tabImgs.active[2] : tabImgs.normal[2]" class="tab-btn tab-3"
            :class="{ 'tab-active': currentTab === 2 }" @click="switchTab(2)">

          <!-- Swiper -->
          <div class="swiper-container" ref="swiperContainer">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(img, i) in slides" :key="i">
                <img :src="img" class="slide-img" />
              </div>
            </div>
          </div>

          <div class="book-pin"></div>

          <div class="dots">
            <img v-for="(dot, index) in slides" :key="index" :src="currentTab === index ? activeDot : normalDot"
              :class="['dot', { 'dot-active': currentTab === index }]" @click="switchTab(index)" />
          </div>

          <!-- Fixed Cats -->
          <img class="cat left-cat" :src="catLeft" />
          <img class="cat right-cat" :src="catRight" />
        </div>
      </div>
    </div>


    <div class="footer-wrapper swiper-slide slide-footer">

      <div class="footer-content zh_HK">
        <div class="top-content" style="margin-bottom: 15px">
          <p>
            <a target="_blank" href="https://law.snell.com.tw/zh-tw/service_agreement.html">服務條款</a>
            <a target="_blank" href="https://law.snell.com.tw/zh-tw/privacy_policy.html">隱私協議</a>
          </p>
        </div>

        <div class="bottom-content">
          <div class="l-logo" style="margin-right: 10px">
            <img src='https://download4.qcplay.com/qcgame-api/gPoRObLEHj6gH4Nttorxvu9j4z5bXnJ13ASABCat.png'>
          </div>
          <div class="r-text">
            <p>*思耐爾數位為最強蝸牛在台港澳的授權代理商。</p>
            <p>*本遊戲因涉及暴力、不當言語之情節，依遊戲軟體分級管理辦法分類為輔12級。</p>
            <p>*注意使用時間，避免沉迷於遊戲。</p>
            <p>*本遊戲為免費遊戲，但遊戲內另提供購買虛擬遊戲幣、物品等付費服務，請依個人興趣及能力適度消費。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getTimeStamp, buriedLogger, analysisParams } from '@/utils/utils';
import { Toast } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";

import Swiper from "swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "snail_5thSpecial",
  components: {
  },

  data() {
    return {
      isPlaying: true, // 默认播放
      gameName: "snail",
      logger: null,
      swiper: null,
      currentTab: 0,
      // 轮播图图片
      slides: [
        'https://download4.qcplay.com/snail/snail_5thLeading/1.png',
        'https://download4.qcplay.com/qcgame-api/DSVOHWIonA2pjKUqmaA2o3pCo2g1Pp7feQpem39j.png',
        'https://download4.qcplay.com/snail/snail_5thLeading/3.png',
      ],
      // tab按钮素材
      tabImgs: {
        normal: [
          'https://download4.qcplay.com/snail/snail_5thLeading/tab1.png',
          'https://download4.qcplay.com/snail/snail_5thLeading/tab2.png',
          'https://download4.qcplay.com/snail/snail_5thLeading/tab3.png',
        ],
        active: [
          'https://download4.qcplay.com/snail/snail_5thLeading/tab1_active.png',
          'https://download4.qcplay.com/snail/snail_5thLeading/tab2_active.png',
          'https://download4.qcplay.com/snail/snail_5thLeading/tab3_active.png',
        ],
      },
      normalDot: 'https://download4.qcplay.com/snail/snail_5thLeading/dot.png',
      activeDot: 'https://download4.qcplay.com/snail/snail_5thLeading/active_dot.png',
      catLeft: 'https://download4.qcplay.com/snail/snail_5thLeading/r_1.png',
      catRight: 'https://download4.qcplay.com/snail/snail_5thLeading/r_2.png',
    };
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.playMusic();
      const { protocol, host, search } = window.location;  // ✅ 多了解析出 search
      const pcLink = `${protocol}//${host}/snail_5thLeading/pc${getTimeStamp()}${search}`;  // ✅ 加上 search
      this.monitoringEquipment(pcLink);  // 假设这是重定向或监测函数
      setTimeout(() => {
        this.initGameSwiper();
      }, 100);

      // 埋点
      const bl = buriedLogger("snail", "蜗牛_港澳台五周年_前导页h5");
      this.logger = bl;
      setTimeout(() => {
        this.logger.sum("蜗牛_港澳台五周年_前导页统计");
      }, 200);
    });
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
  },
  watch: {

  },
  methods: {
    monitoringEquipment(pcLink) {
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = pcLink;
    },
    playMusic() {
      const music = this.$refs.bgMusic;
      // 尝试播放音频
      music.play().then(() => {
        this.isPlaying = true;
      }).catch(() => {
        // 可能被浏览器拦截，处理权限请求或提示
        this.isPlaying = false;
      });
    },
    toggleMusic() {
      const music = this.$refs.bgMusic;
      if (this.isPlaying) {
        music.pause();
        this.isPlaying = false;
      } else {
        music.play();
        this.isPlaying = true;
      }
    },
    slidePrev() {
      this.swiper.slidePrev()
    },
    slideNext() {
      this.swiper.slideNext()
    },
    goLink() {
      const isIOS = /iPhone|iPod|iOS/i.test(navigator.userAgent);
      const platform = isIOS ? 'ios' : 'and';
      const contentId = isIOS ? 'default_ios' : 'default_android';
      // 平台特定事件
      window.fbq('track', `click_${platform}`);
      window.gtag('event', `${platform}点击`);

      // 统一的 purchase 数据
      window.fbq('track', 'Purchase', {
        value: 0.00,
        currency: 'USD',
        content_type: 'product',
        content_ids: [contentId],
        contents: [{ id: contentId, quantity: 1 }]
      });

      // 统一的 andios 埋点
      window.fbq('track', 'click_andios');

      // 埋点
      window.qcq("track", "click", { "store": "android" });
      window.qcq("track", "click", { "store": "ios" });


      const { utm_source, utm_medium, utm_campaign, utm_content } = analysisParams(window.location.href);
      window.qcq("track", "book", {
        game_id: 120,
        utm_source: utm_source || '',
        utm_medium: utm_medium || '',
        utm_campaign: utm_campaign || '',
        utm_content: utm_content || '',
        os: !navigator.userAgent.match(/(iPhone|iPod|ios)/i) ? 'Android' : 'IOS',
      })

      // 自定义统计日志
      this.logger.sum("蜗牛_港澳台五周年_前导页facebook按钮点击次数");

      // 跳转 Facebook
      window.open('https://www.facebook.com/TheMarvelousSnail/posts/pfbid0sQG8VCpx1q1CRANL26jjvpvL4SHmvWoHWmFzMJ4hA8nniA8MSgnsvK8VvZerc16xl', '_blank');
    },
    switchTab(index) {
      this.currentTab = index
      this.swiper.slideTo(index)
    },

    initGameSwiper() {
      this.swiper = new Swiper(this.$refs.swiperContainer, {
        loop: false,
        onSlideChangeEnd: () => {
          this.currentTab = this.swiper.activeIndex;
          console.log('切换完毕，当前页：', this.currentTab);
        },
      })
    },

    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1500,
        className: "toasts"
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setLogger"
    ]),
    ...mapActions(["onInitDataCallback", "onCount", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/snail_5thLeading/index/index.vue